/**
 * Created BY HMSPL 
 * Last Last Modified By Balaji on 10/10/2018
 * Last Modified Description : Added Comment
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatCardModule, MatProgressSpinnerModule, MatTabsModule } from '@angular/material';
import { TabsModule } from 'ngx-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { SignInComponent } from './sign-in/sign-in.component';
import { SessionRoutes } from './session.routing';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { PoDetailsComponent } from './po-details/po-details.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    MatCardModule,
    MatTabsModule,
    TabsModule.forRoot(),
    RouterModule.forChild(SessionRoutes),
    MatProgressSpinnerModule
  ],
  declarations: [
    SignInComponent,
    LoginComponent,
    PoDetailsComponent
  ]
})
export class SessionModule { }
